/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetInboxResponseCounts
 */
export interface GetInboxResponseCounts {
    /**
     * 
     * @type {number}
     * @memberof GetInboxResponseCounts
     */
    type: number;
    /**
     * 
     * @type {number}
     * @memberof GetInboxResponseCounts
     */
    count: number;
}

export function GetInboxResponseCountsFromJSON(json: any): GetInboxResponseCounts {
    return GetInboxResponseCountsFromJSONTyped(json, false);
}

export function GetInboxResponseCountsFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetInboxResponseCounts {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'count': json['count'],
    };
}

export function GetInboxResponseCountsToJSON(value?: GetInboxResponseCounts | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'count': value.count,
    };
}


